exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".load-more-btn {\n  text-align: center;\n  margin: 0px;\n  padding: 5px;\n  border-radius: 0px; }\n\n.new-notification {\n  background-color: #eee; }\n\n.notifications {\n  overflow-y: auto;\n  max-height: 460px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/SPA/src/app/client/components/main/navbar/navbar.component.scss
// module id = ../../../../../src/app/client/components/main/navbar/navbar.component.scss
// module chunks = 0